import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    constructor() { }

    storeData<T>(key: string, data: T): void {
        localStorage.setItem(key, JSON.stringify(data))
    }

    getData<T>(key: string): T | null {
        const storedData = localStorage.getItem(key);
        if (storedData) {
            return JSON.parse(storedData) as T;
        }
        return null;
    }

    clearData(key: string): void {
        localStorage.removeItem(key);
    }


    updateData<T>(key: string, updatedProperties: Partial<T>): void {
        const storedData = this.getData<T>(key);
        if (storedData) {
            const updatedData = { ...storedData, ...updatedProperties };
            this.storeData(key, updatedData)
        }
    }
}
